/**
 * @generated SignedSource<<aaabaae58b3ab3abb18c951bd8443694>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterMeetingOwnership = "ALL_MEETINGS" | "CUSTOM" | "ORGANIZED_BY_ME";
export type UserMeetingRecapSendTo = "ALL" | "INTERNAL" | "JUST_ME" | "NONE";
export type MeetingCopilotSettingsQuery$variables = {};
export type MeetingCopilotSettingsQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly allowMeetingRecording: boolean;
      readonly allowPublicRecap: boolean;
      readonly allowUserAutoRecord: boolean;
      readonly allowVoicePrints: boolean;
      readonly billingAccount: {
        readonly hasAccessToDefaultUserConfigurations: boolean;
      };
      readonly defaultUserAutoRecordSettings: {
        readonly allowUsersToChangeAutoRecordSettings: boolean;
        readonly enabled: boolean;
        readonly meetingOwnershipFilter: FilterMeetingOwnership;
      };
      readonly defaultUserMeetingRecapAutoShareSettings: {
        readonly allowUsersToChangeAlwaysEmailWhenAttendee: boolean;
        readonly allowUsersToChangeSendTo: boolean;
        readonly alwaysEmailWhenAttendee: boolean;
        readonly sendTo: UserMeetingRecapSendTo;
      };
      readonly emailDomainList: ReadonlyArray<string>;
      readonly id: string;
      readonly logo: string;
      readonly name: string;
      readonly primaryAdmin: {
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
      } | null;
    };
    readonly autoPublishRecordingSettings: {
      readonly enabled: boolean;
      readonly externalRecordingsChannel: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly internalRecordingsChannel: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null;
    readonly autoRecordSettings: {
      readonly enabled: boolean;
      readonly id: string;
      readonly meetingOwnershipFilter: FilterMeetingOwnership;
    } | null;
    readonly hasAccessToCopilot: boolean;
    readonly id: string;
    readonly meetingBriefSettings: {
      readonly autoGenerationDelta: number;
      readonly autoGenerationEnabled: boolean;
      readonly id: string;
    };
    readonly meetingRecapAutoShareSettings: {
      readonly alwaysEmailWhenAttendee: boolean;
      readonly id: string;
      readonly sendTo: UserMeetingRecapSendTo;
    } | null;
    readonly settings: {
      readonly googleMeetExtensionRecordingButtonEnabled: boolean;
      readonly voicePrintsEnabled: boolean;
    };
    readonly user: {
      readonly id: string;
      readonly isAccountAdmin: boolean;
    };
    readonly voicePrintCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"CustomRulesBanner" | "CustomRulesSettings">;
  };
};
export type MeetingCopilotSettingsQuery = {
  response: MeetingCopilotSettingsQuery$data;
  variables: MeetingCopilotSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccessToCopilot",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "voicePrintCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountAdmin",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowMeetingRecording",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUserAutoRecord",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowPublicRecap",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowVoicePrints",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "primaryAdmin",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailDomainList",
  "storageKey": null
},
v14 = {
  "alias": "hasAccessToDefaultUserConfigurations",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "default_user_configurations"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"default_user_configurations\")"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingOwnershipFilter",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUsersToChangeAutoRecordSettings",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendTo",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alwaysEmailWhenAttendee",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUsersToChangeSendTo",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowUsersToChangeAlwaysEmailWhenAttendee",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "UserAutoRecordSettings",
  "kind": "LinkedField",
  "name": "autoRecordSettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "UserMeetingRecapAutoShareSettings",
  "kind": "LinkedField",
  "name": "meetingRecapAutoShareSettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v24 = [
  (v0/*: any*/),
  (v5/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "UserRecordingAutoPublishSettings",
  "kind": "LinkedField",
  "name": "autoPublishRecordingSettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "externalRecordingsChannel",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Channel",
      "kind": "LinkedField",
      "name": "internalRecordingsChannel",
      "plural": false,
      "selections": (v24/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "UserMeetingBriefSettings",
  "kind": "LinkedField",
  "name": "meetingBriefSettings",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoGenerationEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoGenerationDelta",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleMeetExtensionRecordingButtonEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voicePrintsEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingCopilotSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomRulesSettings"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomRulesBanner"
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDefaultUserAutoRecordSettings",
                "kind": "LinkedField",
                "name": "defaultUserAutoRecordSettings",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDefaultUserMeetingRecapAutoShareSettings",
                "kind": "LinkedField",
                "name": "defaultUserMeetingRecapAutoShareSettings",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v22/*: any*/),
          (v23/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MeetingCopilotSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v13/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDefaultUserAutoRecordSettings",
                "kind": "LinkedField",
                "name": "defaultUserAutoRecordSettings",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDefaultUserMeetingRecapAutoShareSettings",
                "kind": "LinkedField",
                "name": "defaultUserMeetingRecapAutoShareSettings",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AutoRecordRule",
            "kind": "LinkedField",
            "name": "autoRecordRules",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ruleType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ruleLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filterAttendeeType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filterMinimumAttendees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filterMaximumAttendees",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filterKeywordsContains",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filterKeywordsRestrict",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filterOrganizer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AutoRecordRuleUser",
                "kind": "LinkedField",
                "name": "autoRecordRuleUsers",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isGuest",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserInternalAttributes",
                        "kind": "LinkedField",
                        "name": "internalAttributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "allReports",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v0/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includeAllReports",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2d5bebf81f46fc044e8b1ac0197c3a82",
    "id": null,
    "metadata": {},
    "name": "MeetingCopilotSettingsQuery",
    "operationKind": "query",
    "text": "query MeetingCopilotSettingsQuery {\n  viewer {\n    id\n    hasAccessToCopilot\n    voicePrintCount\n    ...CustomRulesSettings\n    ...CustomRulesBanner\n    user {\n      id\n      isAccountAdmin\n    }\n    account {\n      id\n      logo\n      name\n      allowMeetingRecording\n      allowUserAutoRecord\n      allowPublicRecap\n      allowVoicePrints\n      primaryAdmin {\n        id\n        fullName\n        email\n      }\n      emailDomainList\n      billingAccount {\n        hasAccessToDefaultUserConfigurations: hasAccessToFeature(feature: default_user_configurations)\n        id\n      }\n      defaultUserAutoRecordSettings {\n        enabled\n        meetingOwnershipFilter\n        allowUsersToChangeAutoRecordSettings\n        id\n      }\n      defaultUserMeetingRecapAutoShareSettings {\n        sendTo\n        alwaysEmailWhenAttendee\n        allowUsersToChangeSendTo\n        allowUsersToChangeAlwaysEmailWhenAttendee\n        id\n      }\n    }\n    autoRecordSettings {\n      id\n      enabled\n      meetingOwnershipFilter\n    }\n    meetingRecapAutoShareSettings {\n      id\n      sendTo\n      alwaysEmailWhenAttendee\n    }\n    autoPublishRecordingSettings {\n      id\n      enabled\n      externalRecordingsChannel {\n        id\n        name\n      }\n      internalRecordingsChannel {\n        id\n        name\n      }\n    }\n    meetingBriefSettings {\n      id\n      autoGenerationEnabled\n      autoGenerationDelta\n    }\n    settings {\n      googleMeetExtensionRecordingButtonEnabled\n      voicePrintsEnabled\n    }\n  }\n}\n\nfragment AutoRecordRulesListItemAppliesTo on AutoRecordRule {\n  id\n  ruleLevel\n  autoRecordRuleUsers {\n    user {\n      id\n    }\n    ...AutoRecordRulesListItemUserPill\n  }\n}\n\nfragment AutoRecordRulesListItemDuplicateAutoRecordRule on AutoRecordRule {\n  id\n  ruleType\n}\n\nfragment AutoRecordRulesListItemRule on AutoRecordRule {\n  id\n  ruleType\n  ruleLevel\n  filterAttendeeType\n  filterMinimumAttendees\n  filterMaximumAttendees\n  filterKeywordsContains\n  filterKeywordsRestrict\n  filterOrganizer\n  ...AutoRecordRulesListItemAppliesTo\n  ...AutoRecordRulesListItemRuleDeletionConfirmModal\n  ...AutoRecordRulesListItemDuplicateAutoRecordRule\n  ...CreateAndEditModalRule\n}\n\nfragment AutoRecordRulesListItemRuleDeletionConfirmModal on AutoRecordRule {\n  id\n  ruleType\n}\n\nfragment AutoRecordRulesListItemRuleDescriptionTooltips on Account {\n  emailDomainList\n}\n\nfragment AutoRecordRulesListItemUserPill on AutoRecordRuleUser {\n  includeAllReports\n  user {\n    id\n    fullName\n    image\n    email\n    isGuest\n    internalAttributes {\n      allReports {\n        edges {\n          node {\n            fullName\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment AutoRecordRulesListItemWorkspacePill on Account {\n  id\n  name\n  logo\n}\n\nfragment CopilotSettingsUserFilter on User {\n  id\n  email\n  image\n  fullName\n  isGuest\n}\n\nfragment CreateAndEditModalAccount on Account {\n  id\n  logo\n  name\n  ...AutoRecordRulesListItemRuleDescriptionTooltips\n}\n\nfragment CreateAndEditModalRule on AutoRecordRule {\n  id\n  ruleType\n  autoRecordRuleUsers {\n    includeAllReports\n    user {\n      id\n      ...UserSelectionStepGetIncludesString\n      ...CopilotSettingsUserFilter\n      ...RuleConfigurationStepUserPill\n    }\n  }\n  ruleLevel\n  filterAttendeeType\n  filterMinimumAttendees\n  filterMaximumAttendees\n  filterOrganizer\n  filterKeywordsContains\n  filterKeywordsRestrict\n}\n\nfragment CustomRulesBanner on Viewer {\n  autoRecordRules {\n    ruleLevel\n    id\n  }\n}\n\nfragment CustomRulesSettings on Viewer {\n  account {\n    ...CreateAndEditModalAccount\n    ...AutoRecordRulesListItemWorkspacePill\n    ...AutoRecordRulesListItemRuleDescriptionTooltips\n    id\n  }\n  autoRecordRules {\n    ...AutoRecordRulesListItemRule\n    id\n    ruleType\n    ruleLevel\n    filterAttendeeType\n    filterMinimumAttendees\n    filterMaximumAttendees\n    filterKeywordsContains\n    filterKeywordsRestrict\n    filterOrganizer\n    ...AutoRecordRulesListItemAppliesTo\n    ...AutoRecordRulesListItemRuleDeletionConfirmModal\n    ...AutoRecordRulesListItemDuplicateAutoRecordRule\n    ...CreateAndEditModalRule\n  }\n}\n\nfragment RuleConfigurationStepUserPill on User {\n  id\n  fullName\n  image\n  isGuest\n  email\n}\n\nfragment UserSelectionStepGetIncludesString on User {\n  fullName\n  internalAttributes {\n    allReports {\n      edges {\n        node {\n          fullName\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "72936f011b794e2725355d66a2a5c1d0";

export default node;
